// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ibSABK6wF50hU2nvqiBF{text-align:center;border:1px solid var(--black-10);background:var(--green-10);color:var(--green-90);border-radius:4px;align-items:center;gap:6px;padding:1px 4px 2px;font-size:11px;font-style:normal;font-weight:500;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recommendedLabel": `ibSABK6wF50hU2nvqiBF`
};
export default ___CSS_LOADER_EXPORT___;
